module.exports = __webpack_public_path__ + "img/PN.c841d7f9.png";